import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { TranslatePipe } from '@ngx-translate/core';
import { LinkedinIconComponent } from './social-icons/linkedin/linkedin-icon.component';
import { TiktokIconComponent } from './social-icons/tiktok/tiktok-icon.component';
import { InstagramIconComponent } from '@app/shared/components/loyalty-club-footer/social-icons/instagram/instagram-icon.component';
import { FacebookIconComponent } from './social-icons/facebook/facebook-icon.component';
import { IconComponent } from '@app/shared/components/icon/icon.component';

@Component({
  selector: 'app-loyalty-club-footer',
  templateUrl: './loyalty-club-footer.component.html',
  imports: [
    TranslatePipe,
    LinkedinIconComponent,
    TiktokIconComponent,
    InstagramIconComponent,
    FacebookIconComponent,
    IconComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoyaltyClubFooterComponent {
  private settingsService = inject(SettingsService);

  protected currentYear = new Date().getFullYear();
  protected settings = this.settingsService.settings;
}
